module.exports = __webpack_public_path__ + "media/images/icons/send-2ef058b152b5a4179032109236b48b54.svg";